(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.header-wrapper');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    // Scrolling DOWN — fix it in place but hidden
    this.header.classList.add('shopify-section-header-sticky');
    // Small delay so position:fixed is applied before we animate
    requestAnimationFrame(() => {
      this.header.classList.remove('is-visible');
    });

  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    // Scrolling UP — slide down into view
    if (!this.preventReveal) {
      this.header.classList.add('shopify-section-header-sticky');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.header.classList.add('is-visible');
        });
      });
    }
    this.preventReveal = false;

  } else if (scrollTop <= this.headerBounds.top) {
    // Back at top — restore normal flow
    this.header.classList.remove('shopify-section-header-sticky', 'is-visible');
  }

  this.currentScrollTop = scrollTop;
 }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
